var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal-code-editor", attrs: { id: "modalCodeEditorId" } },
    [
      _c("div", { staticClass: "modal-code-editor__header" }, [
        _c("div", { staticClass: "modal-code-editor__header__title" }, [
          _c("img", {
            attrs: { src: require("@/assets/new-form-ui/code-editor.svg") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("Code Editor")]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.viewTitle))])
        ]),
        _vm._v(" "),
        _c(
          "p",
          {
            staticClass: "modal-code-editor__header__icon",
            on: {
              click: function($event) {
                _vm.$emit("close")
              }
            }
          },
          [_vm._v("\n      ×\n    ")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-code-editor__content" },
        [
          _c(
            "b-form",
            [
              _c("label", [_vm._v(" Script ")]),
              _vm._v(" "),
              _vm.isShowEditor
                ? _c("j-monaco-editor", {
                    ref: "scriptEditor",
                    attrs: {
                      value: _vm.viewData,
                      language: "json",
                      height: "calc(90vh - 150px)"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-code-editor__footer" }, [
        _c(
          "button",
          {
            staticClass: "button-border",
            on: {
              click: function($event) {
                _vm.$emit("close")
              }
            }
          },
          [_vm._v("\n      Close\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          { staticClass: "button-blue", on: { click: _vm.update } },
          [_vm._v("\n      Update\n    ")]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ac0c52c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac0c52c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/popup/ModalCodeEditor.vue
// module id = null
// module chunks = 